// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 597) return "static/js/BingoGames.c6a17061e5cf761ee961.chunk.js";
	if (chunkId === 237) return "static/js/GameDetails.eb4fd4015008baca83f1.chunk.js";
	if (chunkId === 455) return "static/js/SearchCategory.6b24cac189663ec3ef28.chunk.js";
	if (chunkId === 94) return "static/js/SearchMoreResults.a432c2d857c40f035f82.chunk.js";
	if (chunkId === 86) return "static/js/SimplifiedHeader.51cdfb29507dab3bea43.chunk.js";
	if (chunkId === 660) return "static/js/SearchHeader.71026822c355a4d663e4.chunk.js";
	if (chunkId === 265) return "static/js/SearchHistory.6310aaa486f6050d497f.chunk.js";
	if (chunkId === 606) return "static/js/ErrorPage.c0d40374774894ccc70a.chunk.js";
	if (chunkId === 32) return "static/js/GameModal.192af468f21b595ace7b.chunk.js";
	if (chunkId === 700) return "static/js/Copy.08ec456fc960713ae4cb.chunk.js";
	if (chunkId === 990) return "static/js/FloatingIcon.384f9a0f59dc6da0e8ab.chunk.js";
	if (chunkId === 620) return "static/js/ErrorContainer.a191e0058b6c66d79dc4.chunk.js";
	if (chunkId === 347) return "static/js/CookieBanner.78da7fdc6acc85d36a12.chunk.js";
	if (chunkId === 430) return "static/js/Menu.588cda72aaf30e11ff50.chunk.js";
	if (chunkId === 578) return "static/js/SearchDesktopWrapper.910867fc3a92c534c80d.chunk.js";
	if (chunkId === 896) return "static/js/SearchWrapper.93b7296bcac5c18acd6e.chunk.js";
	if (chunkId === 499) return "static/js/Download.3d29d21b414ad61b6177.chunk.js";
	if (chunkId === 410) return "static/js/SearchSuggestions.596b3ebe289a3651506f.chunk.js";
	if (chunkId === 356) return "static/js/Steps.e2883ceb05d4d23181c3.chunk.js";
	if (chunkId === 496) return "static/js/BannerStandalone.48a103575b44378fc0ee.chunk.js";
	if (chunkId === 207) return "static/js/VideoModal.1b3385ca0475ff82f416.chunk.js";
	if (chunkId === 29) return "static/js/ProvidersFilter.fe5d26130e2555bcebf8.chunk.js";
	if (chunkId === 401) return "static/js/IdlePopup.5f9966d8afece1ff69d0.chunk.js";
	if (chunkId === 899) return "static/js/GameBanner.0cefe8694afdf08a9a25.chunk.js";
	if (chunkId === 843) return "static/js/GameDual.b024a3a48ddd0bb9b8b3.chunk.js";
	if (chunkId === 349) return "static/js/GameList.112db9a0b2aa4694509d.chunk.js";
	if (chunkId === 827) return "static/js/Grid.b150bb8f392013893546.chunk.js";
	if (chunkId === 160) return "static/js/ExtendedGrid.d96137d87098c1bda804.chunk.js";
	if (chunkId === 659) return "static/js/WidgetGrid.114adc508919741eead3.chunk.js";
	// return url for filenames based on template
	return undefined;
};